var api = require("!../../../style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../postcss-loader/src/index.js??ruleSet[1].rules[2].use[2]!../../../resolve-url-loader/index.js!./style.css");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};